<template>
  <div class="school-select-modal">
    <Modal
      :visible.sync="visible"
      :closable="false"
      :mask-closable="false"
      :width="600"
    >
      <i-col
        span="6"
        class="state-list-container list-container"
      >
        <ul class="state-list">
          <li
            :class="{ active: currentState === 'hot'}"
            @click="currentState = 'hot'"
          >
            热门
          </li>
          <li
            v-for="state in stateList"
            :class="{ active: currentState === state }"
            @click="currentState = state"
          >
            {{ state }}
          </li>
        </ul>
      </i-col>
      <i-col
        span="18"
        class="school-list-container list-container"
      >
        <ul class="school-list">
          <li
            v-for="school in currentSchoolList"
            style="cursor: pointer;"
            @click="handleSchoolClick(school)"
          >
            <b>{{ school.abbr }}</b>{{ school.name }}
          </li>
        </ul>
      </i-col>
    </Modal>
  </div>
</template>

<script>
import api from '../api';
import store from '../vuex/store';
import { getSchool } from '../vuex/getters';
import { setSchool } from '../vuex/actions';
import _ from 'lodash';
import router from '../router';

export default {
  name: 'SchoolSelect',

  store: store,
  vuex: {
    actions: {
      setSchool,
    },
    getters: {
      school: getSchool,
    },
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      schoolList: {},
      currentState: 'hot',
    };
  },

  computed: {
    stateList: function () {
      return Object.keys(this.schoolList);
    },
    currentSchoolList: function () {
      return this.schoolList[this.currentState] || [];
    },
  },

  methods: {
    getSchoolList () {
      this.$http
        .get(api.school.list)
        .then(res => {
          res.body.hot = _.chain(res.body).get('school').filter('hot').value();
          delete res.body.school;
          this.schoolList = res.body;
        });
    },
    handleSchoolClick (school) {
      this.setSchool(school);
      router.go({ name: 'schoolIndex', params: { schoolAbbr: school.abbr } });
    },
  },

  ready () {
    this.getSchoolList();
  },
};

</script>

<style lang="less">
.school-select-modal {
    .ivu-modal {
        top: 10px;
    }
    .ivu-modal-content {
        overflow: hidden;
    }
    .ivu-modal-body {
        padding: 0;
    }
    .ivu-modal-footer {
        display: none;
    }
}
</style>

<style scoped lang="less">
@import "../styles/theme.less";

.list-container {
    max-height: 400px;
    overflow-y: scroll;

    ul {
        padding: 10px 0;
        li {
            padding: 1em;
            border-bottom: solid 1px #eee;
            &:first-child {
                border-top: solid 1px #eee;
            }

            &:hover {
                background: #eee;
            }

            &.active {
                color: #fff;
                background: @link-color;
                &:hover {
                    background: @link-hover-color;
                }
            }
        }
    }
}
.state-list-container {
    font-size: 1.2em;
    border-right: solid 1px #eee;
}
.school-list {
    b {
        padding-right: 1em;
    }
}
</style>



// WEBPACK FOOTER //
// schoolSelect.vue?1926f147